var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.11584 3.75758C4.28455 2.14323 5.73825 1 7.47569 1H8.52431C10.2618 1 11.7155 2.14323 11.8842 3.75758L12.2348 7.30303C12.3619 8.51954 12.9113 9.75338 13.7994 10.6515C14.2434 11.1005 13.9022 12.0303 13.2477 12.0303H2.75233C2.09777 12.0303 1.75663 11.1005 2.20061 10.6515C3.08866 9.75338 3.63806 8.51954 3.76519 7.30303L4.11584 3.75758Z",
    stroke: "#212143",
    strokeWidth: 1.20741,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13794 12.0303H9.86207V12.2273C9.86207 13.2063 9.0284 14 8.00001 14C6.97161 14 6.13794 13.2063 6.13794 12.2273V12.0303Z",
    stroke: "#212143",
    strokeWidth: 1.20741,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.dd86d3f24577e7ae8322b81565c88417.svg";
export { ForwardRef as ReactComponent };